import React from "react";
import { DishesContext } from "../../context/dishes";
import DishesList from "./DishesList";
import { PageDishesWrapper } from "../Layout/PageDishesWrapper";
import { PaginateButton } from "../Layout/Elements";


export const PageDishes = ({ handleClick }) => {
  const { sorted, page, setPage } = React.useContext(DishesContext);
  

   

  if (!sorted[page]) {
  return <h3 className='search-errors'>Your search query returned nothing</h3>
  }
  else {
return (
      <PageDishesWrapper>
        <section className="py-5  content-inside mb-5">
          <div className="container">
            <div className="row">
              <DishesList dishes={sorted[page]} />
              <div className="buttons-aligned">
                  {sorted.map((_, index) => {
                    return (
                      <PaginateButton
                        width="45px"
                        radius="50%"
                        padding="10px"
                        bg="var(--paginateStandard)"
                        key={index}
                        onClick={() => setPage(index)}
                        className={`ml-2 ${
                          page === index && `paginate-current`
                        }`}
                      >
                        {index + 1}
                      </PaginateButton>
                    );
                  })}
              </div>
            </div>
          </div>
        </section>
      </PageDishesWrapper>
    );
  }
};

export { PageDishes as default };
